"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var json_1 = require("../../../common/helpers/json");
function AdminEventsCreateController($scope, $state, UserService, EventsModel, FlashService, BatchCreateService, campuses, vehicles, classrooms, instructors, VueStoreFactory) {
    var vm = this;
    vm.instructors = [{ id: 0, fullname: "None" }].concat(instructors);
    vm.locations = campuses;
    vm.vehicles = [{ id: 0, name: "None" }].concat(vehicles);
    vm.classrooms = classrooms;
    vm.overrideInstructorSettings = "N";
    vm.user = UserService.getCurrentUser();
    vm.formData = {
        school_id: vm.user.school_id,
        duration: {
            hours: "0",
            minutes: "0",
        },
        instructor: vm.instructors[0],
        classroom: vm.classrooms[0],
        vehicle: vm.vehicles[0],
    };
    vm.batchCreate = batchCreate;
    vm.clearField = clearField;
    vm.submit = submit;
    vm.updateTime = updateTime;
    vm.updateDate = updateDate;
    init();
    function batchCreate() {
        BatchCreateService.setEvent(vm.formData);
        $state.go("drivecoach.admin.events.batch");
    }
    function init() {
        vm.school = vm.user.school;
        vm.policies = {};
        // Read policies synchronously from the Vuex store (populated at admin
        // startup by admin.controller.ts configureCashier).
        var storePolicies = VueStoreFactory.state.auth.policies.policies;
        storePolicies.forEach(function (policy) {
            var policyName = policy.name;
            vm.policies[policyName] = { id: policy.id };
            var policyMeta = {};
            policy.policymeta.forEach(function (meta) {
                policyMeta[meta.meta_key] = (0, json_1.isJson)(meta.meta_value)
                    ? JSON.parse(meta.meta_value)
                    : meta.meta_value;
            });
            vm.policies[policyName].policymeta = policyMeta;
        });
        if (vm.policies.events.policymeta.date === "today") {
            vm.formData.date = new Date();
        }
        if (vm.policies.events.policymeta.date === "+3 days") {
            vm.formData.date = (0, time_1.addDays)(new Date(), 3);
        }
        if (vm.policies.events.policymeta.date === "+7 days") {
            vm.formData.date = (0, time_1.addDays)(new Date(), 7);
        }
        vm.formData.time = (0, time_1.timeStringToDate)(vm.policies.events.policymeta.time + ":00");
        if (vm.policies.events.policymeta.minimum_session_length) {
            var dur = (0, time_1.minutesToHoursAndMinutes)(vm.policies.events.policymeta.minimum_session_length);
            vm.formData.duration.hours = dur.hours.toString();
            vm.formData.duration.minutes = dur.minutes.toString();
        }
    }
    function clearField(field) {
        vm.event[field] = null;
    }
    function submit(isValid) {
        var payload = Object.assign({}, vm.formData);
        vm.submitted = true;
        if (isValid) {
            payload.formattedDate = (0, time_1.formatDateTime)(payload.date, "MM/DD/YYYY");
            payload.formattedTime = (0, time_1.formatDateTime)(payload.time, "HH:mm:ss");
            // Ensure duration values are integers for the API
            payload.duration.hours = parseInt(payload.duration.hours, 10);
            payload.duration.minutes = parseInt(payload.duration.minutes, 10);
            if (payload.instructor.id === 0) {
                delete payload.instructor;
            }
            EventsModel.create(payload).then(function (response) {
                FlashService.setMessage({ type: "success", message: response.message });
                vm.submitted = false;
                $state.go("drivecoach.admin.calendar", {}, { reload: true });
            });
        }
        else {
            FlashService.setMessage({
                type: "error",
                message: "Please fill in the form.",
            });
        }
    }
    function updateDate(newDate) {
        vm.formData.date = newDate.selected[0];
    }
    function updateTime(newTime) {
        vm.formData.time = newTime.selected[0];
    }
}
AdminEventsCreateController.$inject = [
    "$scope",
    "$state",
    "UserService",
    "EventsModel",
    "FlashService",
    "BatchCreateService",
    "campuses",
    "vehicles",
    "classrooms",
    "instructors",
    "VueStoreFactory",
];
exports.default = AdminEventsCreateController;
